import { useState } from "react";
import { Box, Button, Container, Grid, Typography } from "@mui/material";
import { IconArrowLeft, IconCalendarEvent } from "@tabler/icons-react";
import RegistrarEventoInternacionalDialog from "../registrarEventoInternacionalDialog";
import UploadStatements from "../../arquivo/abaStatements/uploadStatements";
import ListaStatements from "../../arquivo/abaStatements/listaStatements";
import RenderAnimation from "../../../util/ui/renderAnimation";
import { Link } from "react-router-dom";

export default function ArquivoInternacional() {
  const [registrarAberto, setRegistrarAberto] = useState(false);
  return (
    <Container
      maxWidth="lg"
      sx={{
        padding: {
          md: 3,
          xs: 2,
        },
      }}
    >
      <Grid container spacing={3}>
        {/* Header */}
        <Grid item xs={12}>
          <RenderAnimation
            key="Header"
            delay={0}
            render={() => (
              <Box display="flex" flexDirection="column" gap={2}>
                {/* "Voltar" é `outlined secondary` em todas as outras telas
                    (darf, fechamento, declaração, nota, statement). Em `text`
                    sem cor o rótulo caía em `primary.main` — 2,57:1 no dark. */}
                <Button
                  variant="outlined"
                  color="secondary"
                  startIcon={<IconArrowLeft />}
                  component={Link}
                  to="/internacional"
                  sx={{ alignSelf: "flex-start" }}
                >
                  Voltar
                </Button>
                <Box display="flex" flexDirection="column" gap={0.5}>
                  <Typography variant="eyebrow" color="text.secondary">
                    Mercado internacional
                  </Typography>
                  <Typography variant="h1" color="text.primary">
                    Gerenciar Statements
                  </Typography>
                </Box>
                <Typography
                  variant="body1"
                  color="text.secondary"
                  sx={{ maxWidth: "60ch" }}
                >
                  Importe seus statements do Mercado Internacional para calcular
                  automaticamente impostos e resultados.
                </Typography>
                {/* Desdobramento/grupamento não vem dos statements ainda:
                    registro manual, mesmo diálogo do card de lançamentos. */}
                <Button
                  variant="outlined"
                  color="secondary"
                  startIcon={<IconCalendarEvent size={16} />}
                  onClick={() => setRegistrarAberto(true)}
                  sx={{ alignSelf: "flex-start" }}
                >
                  Registrar evento corporativo
                </Button>
                {registrarAberto && (
                  <RegistrarEventoInternacionalDialog
                    open={registrarAberto}
                    onClose={() => setRegistrarAberto(false)}
                  />
                )}
              </Box>
            )}
          />
        </Grid>

        {/* Upload Section */}
        <Grid item xs={12}>
          <RenderAnimation
            key="Upload"
            delay={150}
            render={() => <UploadStatements />}
          />
        </Grid>

        {/* Lista Section */}
        <Grid item xs={12}>
          <RenderAnimation
            key="Lista"
            delay={300}
            render={() => <ListaStatements />}
          />
        </Grid>
      </Grid>
    </Container>
  );
}
